import { render } from "./PlayRoomView.vue?vue&type=template&id=a8f1d38c&scoped=true"
import script from "./PlayRoomView.vue?vue&type=script&lang=js"
export * from "./PlayRoomView.vue?vue&type=script&lang=js"

import "./PlayRoomView.vue?vue&type=style&index=0&id=a8f1d38c&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8f1d38c"]])

export default __exports__